import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M11.429 7.422c2.167.853 3.576 2.978 4.543 6.293.154.53-.15 1.085-.68 1.24-.53.155-1.086-.15-1.24-.68-1.067-3.658-2.523-5.278-5.038-5.278-1.384 0-2.423.505-3.267 1.527-.352.426-.982.487-1.408.135-.426-.351-.486-.982-.135-1.408.683-.827 1.487-1.435 2.411-1.81-.777-.672-1.27-1.666-1.27-2.775C5.346 2.64 6.987 1 9.013 1c2.024 0 3.665 1.64 3.665 3.666 0 1.099-.483 2.084-1.248 2.756zm-2.417-1.09c.92 0 1.665-.745 1.665-1.666 0-.92-.745-1.666-1.665-1.666-.921 0-1.666.745-1.666 1.666 0 .92.745 1.666 1.666 1.666z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M7.602 13.663H1.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5.853l-.046-.046c-.293-.293-.292-.768 0-1.06.294-.294.769-.293 1.061 0l1.325 1.326c.293.292.293.767 0 1.06l-1.325 1.325c-.293.293-.768.293-1.06 0-.293-.293-.293-.768 0-1.06l.044-.045z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M15.529 11.316c3.613.955 5.885 4.118 7.43 9.41.154.53-.15 1.085-.68 1.24-.531.155-1.086-.15-1.24-.68-1.657-5.678-3.995-8.28-8.04-8.28-2.229 0-3.927.825-5.289 2.474-.352.426-.982.486-1.408.134-.426-.352-.486-.982-.134-1.408 1.19-1.442 2.628-2.411 4.328-2.878C9.005 10.463 8.002 8.848 8.002 7c0-2.761 2.238-5 5-5 2.761 0 5 2.239 5 5 0 1.84-.993 3.447-2.473 4.316zM13.002 10c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M11.582 20.005H3c-.552 0-1-.448-1-1s.448-1 1-1h8.584l-.283-.283c-.39-.39-.39-1.024 0-1.414.39-.39 1.023-.39 1.414 0l1.989 1.989c.39.39.39 1.023 0 1.414l-1.989 1.99c-.39.39-1.023.39-1.414 0-.39-.39-.39-1.023 0-1.414l.281-.282z"
        />
      </g>
    </svg>
  ),
};
